import React from 'react'
import './Remedycard.css'
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import GALLERY11 from '../images/11.jpg';
import GALLERY9 from '../images/9.jpg';
import GALLERY12 from '../images/12.jpg';
export default function Remedycard() {
  return (
    <>
    
    
    <div><Navbar/></div>
    
    
   <section id="nadi-remedies" style={{ fontFamily: 'Arial, sans-serif', marginTop: '10rem' }}>


<center>
        <h2>Remedies</h2>
        </center>
  <div
    id="nadi-remedies-grid"
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '20px',
    }}
  >
    <div
      id="nadi-remedy-1"
      style={{
        background: 'linear-gradient(135deg, #ff9a9e, #fad0c4)',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        transition: 'transform 0.3s, box-shadow 0.3s',
        border: '3px solid #ff6f61',
      }}
    >
      <img
        src={GALLERY11}
        alt="Nadi Astrology Remedies"
        style={{
          width: '100%',
          height: '200px',
          objectFit: 'cover',
          borderRadius: '10px 10px 0 0',
        }}
      />
      <h2
        id="nadi-remedy-title-1"
        style={{
          background: '#ff6f61',
          color: 'white',
          margin: 0,
          padding: '15px',
          textAlign: 'center',
        }}
      >
        Nadi Astrology Remedies
      </h2>
      <p style={{ padding: '15px', color: '#333' }}>
      At the moment of birth, an individual's soul carries the weight of its previous actions, encompassing both virtuous and unvirtuous deeds. Consequently, the soul is imbued with various karmic influences at the time of its earthly arrival. A soul that has engaged solely in benevolent actions in prior existences will experience favorable outcomes in this life. Conversely, a soul burdened by malevolent actions will encounter adverse consequences and suffering.
      </p>
      <p style={{ padding: '15px', color: '#333' }}>
      Thus, the soul is accountable for the joys and sorrows it faces in this lifetime. An ideal soul should strive to refrain from negative actions and instead focus on performing good deeds. It is often stated that the material realm is an illusion, obscuring the truths of past lives from the individual.
      </p>
    </div>

    <div
      id="nadi-remedy-2"
      style={{
        background: 'linear-gradient(135deg, #a18cd1, #fbc2eb)',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        transition: 'transform 0.3s, box-shadow 0.3s',
        border: '3px solid #8e44ad',
      }}
    >
      <img
        src={GALLERY9}
        alt="Importance of Remedies"
        style={{
          width: '100%',
          height: '200px',
          objectFit: 'cover',
          borderRadius: '10px 10px 0 0',
        }}
      />
      <h2
        id="nadi-remedy-title-2"
        style={{
          background: '#8e44ad',
          color: 'white',
          margin: 0,
          padding: '15px',
          textAlign: 'center',
        }}
      >
        Importance of Remedies
      </h2>
      <p style={{ padding: '15px', color: '#333' }}>
      As a result, individuals often struggle to comprehend the origins of their joys and sufferings. A soul that grasps the profound truths of its existence and adheres to a righteous path will undoubtedly reap the rewards of its virtuous conduct.

      </p>
      <p style={{ padding: '15px', color: '#333' }}>
      The adage "As you sow, so shall you reap" encapsulates this principle; a bountiful harvest can only be achieved through the planting of good deeds. The outcome is contingent upon the quality of the actions undertaken. According to natural law, the Almighty governs the world based on the deeds accumulated from previous lives. The principle that "every action has an equal and opposite reaction" holds true.</p>
    </div>

    <div
      id="nadi-remedy-3"
      style={{
        background: 'linear-gradient(135deg, #ffecd2, #fcb69f)',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        transition: 'transform 0.3s, box-shadow 0.3s',
        border: '3px solid #f39c12',
      }}
    >
      <img
        src={GALLERY12}
        alt="The Three Paths"
        style={{
          width: '100%',
          height: '200px',
          objectFit: 'cover',
          borderRadius: '10px 10px 0 0',
        }}
      />
      <h2
        id="nadi-remedy-title-3"
        style={{
          background: '#f39c12',
          color: 'white',
          margin: 0,
          padding: '15px',
          textAlign: 'center',
        }}
      >
        The Three Paths
      </h2>
      <p style={{ padding: '15px', color: '#333' }}>
      By contemplating and actively engaging in good deeds in our daily lives, we can unlock the full potential of our existence. The pursuit of kindness and selflessness not only enriches our soul but also creates a ripple effect of positivity in the world.
      </p>
      <p style={{ padding: '15px', color: '#333' }}>
        Three significant paths have been outlined for the atonement of sins, ensuring redemption
        and a harmonious existence.
      </p>
    </div>
  </div>
</section>



    
    {/* <div><Footer/></div> */}
    </>
  )
}
